<template>
  <div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <div class="bordered pad">
          <h1>Add notes to the file</h1>
        </div>
      </div>
    </div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small-12">
        <div class="bordered pad">
          <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
              <vue-editor
                id="notesEditor"
                v-bind:editorToolbar="customToolbar"
                v-model="notes"
                placeholder="Must include a note to explain what your evidence is."
                rows="12">
              </vue-editor>
              <br />
              <button @click="saveFile" class="button">Save Evidence</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="message.length > 0"
      class="message-wrap">
      <span class="close-message" v-on:click="reload()">X</span>
      <p class="message-text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'AddFile',
  data() {
    return {
      notes: '',
      message: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: '1' }, { header: '2' }],
        ['link'],
      ],
    };
  },
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    courseChosen() {
      return this.$store.getters.courseChosen;
    },
  },
  methods: {
    saveFile() {
      const postData = {
        notes: this.notes,
      };
      axios.post(`/files/addTwo/${this.$route.params.id}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`, postData)
        .then((response) => {
          if (response.data.response.result === true) {
            this.message = 'The file has been added successfully.';
          } else {
            this.message = 'The file could not be added - please check the details';
          }
        });
    },
    reload() {
      // eslint-disable-next-line
      location.reload();
    },
    clearMessage() {
      this.message = '';
    },
    setCurrentLearner() {
      this.$store.dispatch('selectCurrentLearner', this.user.id);
    },
  },
  mounted() {
    this.getFileHeadings();
    this.getUser();
  },
};
</script>
